import { render, staticRenderFns } from "./StudentServicesComponent.vue?vue&type=template&id=1e4ec508&"
import script from "./StudentServicesComponent.vue?vue&type=script&lang=ts&"
export * from "./StudentServicesComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e4ec508')) {
      api.createRecord('1e4ec508', component.options)
    } else {
      api.reload('1e4ec508', component.options)
    }
    module.hot.accept("./StudentServicesComponent.vue?vue&type=template&id=1e4ec508&", function () {
      api.rerender('1e4ec508', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StudentDashboard/OutProcessing/StudentServicesComponent.vue"
export default component.exports